import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonthlyExpensesComponent } from './monthly-expenses.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseHighlightModule } from '@fuse/components';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from 'app/angular-material.module';
import { SharedModule } from '../common/shared.module';
import { FuseWidgetModule } from '../fuse/components/widget/widget.module';
import { FuseShortcutsModule } from '../fuse/components/shortcuts/shortcuts.module';
import { ExpensesHeaderComponent } from './components/expenses-header/expenses-header.component';
import { ExpensesListComponent } from './components/expenses-list/expenses-list.component';
import { ExpensesDateComponent } from './components/expenses-header/expenses-date/expenses-date.component';

@NgModule({
  declarations: [
    MonthlyExpensesComponent, 
    ExpensesHeaderComponent,
    ExpensesListComponent,
    ExpensesDateComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    FuseHighlightModule,
    FuseWidgetModule,
    RouterModule,
    AngularMaterialModule,
    SharedModule,
    FuseShortcutsModule
  ]
})
export class MonthlyExpensesModule { }
